(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carbon-footprint"] && !Shopify.designMode) return;
  try {
    


document.addEventListener('DOMContentLoaded', () => {
    
  document.querySelectorAll('[data-carbon-footprint-metaobject]').forEach(function(el) {
    const uniqueIdentifier = el.dataset.uniqueIdentifier;

    const productTypeBtns = document.querySelectorAll(`[data-unique-identifier="${uniqueIdentifier}"] [data-product-type-btn]`);
    const productTypeContainers = document.querySelectorAll(`[data-unique-identifier="${uniqueIdentifier}"] [data-carbon-footprint-product-type]`);
    const circleWrappers = document.querySelectorAll(`[data-unique-identifier="${uniqueIdentifier}"] [data-circle-wrapper]`);
    const circleTypes = document.querySelectorAll(`[data-unique-identifier="${uniqueIdentifier}"] [data-circle-type]`);

    let currentCircleType = circleTypes[0].getAttribute('data-circle-type');

    productTypeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const productType = btn.getAttribute('data-product-type-btn');

        if (btn.classList.contains('active')) {
          return;
        }

        productTypeBtns.forEach(button => {
          button.classList.remove('active');
        });

        btn.classList.add('active');

        productTypeContainers.forEach(container => {
          container.hidden = container.getAttribute('data-carbon-footprint-product-type') !== productType;
        });

        // Select the corresponding circle for the new product type
        if (currentCircleType) {
          circleTypes.forEach(circle => {
            if (circle.getAttribute('data-circle-type') === currentCircleType) {
              circle.classList.remove('active');
              circle.click();
              circle.classList.add('active');
            }
          });
        }
      });
    });

    circleTypes.forEach(circle => {
      circle.addEventListener('click', () => {
        const circleType = circle.getAttribute('data-circle-type');

        if (circle.classList.contains('active')) {
          return;
        }

        circleTypes.forEach(circle => {
          circle.classList.remove('active');
        });

        circle.classList.add('active');

        circleWrappers.forEach(wrapper => {
          wrapper.hidden = wrapper.getAttribute('data-circle-wrapper').split('--')[1] !== circleType;
        });

        // Store the currently selected circle type
        currentCircleType = circleType;

        // Update all circles for each product type to the selected circle type
        circleTypes.forEach(circle => {
          if (circle.getAttribute('data-circle-type') === currentCircleType) {
            circle.classList.add('active');
          }
        });
      });
    });
  })
})
  
  

  } catch(e) { console.error(e); }
})();
})();
